import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { FolderPicker, FolderRow } from './FolderTree';

export default function ValidateDocumentModal({
  projectId,
  documentId,
  open,
  onClose,
  onValidated,
}: {
  projectId: number;
  documentId: number;
  open: boolean;
  onClose: () => void;
  onValidated: () => void;
}) {
  const [folders, setFolders] = useState<FolderRow[]>([]);
  const [folderId, setFolderId] = useState<number | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get<{ folders: FolderRow[] }>(`/projects/${projectId}/folders`).then((r) => {
      setFolders(r.folders);
    });
  }, [open, projectId]);

  async function createFolder(name: string, parentId: number | null): Promise<number | null> {
    const r = await api.post<{ id: number }>(`/projects/${projectId}/folders`, {
      name,
      parent_id: parentId,
    });
    const list = await api.get<{ folders: FolderRow[] }>(`/projects/${projectId}/folders`);
    setFolders(list.folders);
    return r.id ?? null;
  }

  async function confirm() {
    setBusy(true);
    try {
      await api.post(`/documents/${documentId}/valider`, { folder_id: folderId });
      onValidated();
      onClose();
    } catch (e) {
      alert(e instanceof Error ? e.message : 'Validation impossible');
    } finally {
      setBusy(false);
    }
  }

  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 520 }}>
        <div className="card-meta">Validation</div>
        <h2 style={{ margin: '2px 0 14px' }}>Où ranger ce document ?</h2>
        <FolderPicker
          folders={folders}
          value={folderId}
          onChange={setFolderId}
          onCreateFolder={createFolder}
        />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 18 }}>
          <button className="btn btn-ghost" onClick={onClose}>
            Annuler
          </button>
          <button className="btn btn-valider" onClick={confirm} disabled={busy}>
            {busy ? 'Validation…' : '✓ Valider et ranger'}
          </button>
        </div>
      </div>
    </div>
  );
}
